import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-twitter-faq",
  "use": "icon-twitter-faq-usage",
  "viewBox": "0 0 14 11.379",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 11.379\" id=\"icon-twitter-faq\">\n  <path id=\"icon-twitter-faq_twitter\" d=\"M13.973,3.6a5.833,5.833,0,0,1-1.648.452,2.892,2.892,0,0,0,1.262-1.588,5.928,5.928,0,0,1-1.824.691A2.87,2.87,0,0,0,6.872,5.771,8.13,8.13,0,0,1,.957,2.78,2.813,2.813,0,0,0,.568,4.224,2.87,2.87,0,0,0,1.844,6.614a2.861,2.861,0,0,1-1.3-.359v.035A2.872,2.872,0,0,0,2.847,9.1a2.914,2.914,0,0,1-1.29.05,2.879,2.879,0,0,0,2.686,1.993,5.756,5.756,0,0,1-3.56,1.228A6.092,6.092,0,0,1,0,12.337a8.164,8.164,0,0,0,4.408,1.289,8.107,8.107,0,0,0,8.165-8.158c0-.122,0-.245-.009-.367A5.8,5.8,0,0,0,14,3.613Z\" transform=\"translate(0 -2.246)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/twitter-faq.svg
// module id = 180
// module chunks = 0 1 2